import { MarkovVariable } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovVariableList = (
    variableList: types.MarkovVariableList,
    variableListByName: types.MarkovVariableListByName,
) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_LIST),
    variableList,
    variableListByName,
})
export const setMarkovVariableIds = (variableIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_IDS),
    variableIds,
})
export const setMarkovVariableEdit = (variable: MarkovVariable) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_EDIT),
    variable,
})
export const setMarkovVariableDelete = (variable: MarkovVariable) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_DELETE),
    variable,
})
export const setMarkovVariableSort = (sortColumn: keyof MarkovVariable, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovVariableFilters = (filters: types.MarkovVariableFilters) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_FILTERS),
    filters,
})
export const setMarkovVariableReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_RELOAD_LIST),
    value,
})
export const setMarkovVariableReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_VARIABLE_RELOAD_EDIT),
    value,
})
